import { render, staticRenderFns } from "./sendFile.vue?vue&type=template&id=218b4d98"
import script from "./sendFile.vue?vue&type=script&lang=js"
export * from "./sendFile.vue?vue&type=script&lang=js"
import style0 from "./sendFile.vue?vue&type=style&index=0&id=218b4d98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports